import { useEffect, useMemo, useRef, useState } from "react";
import { Button as BSButton, Spinner } from "react-bootstrap";
import { InputAdornment, TextField } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useBilling, useSwitchBill } from "../Kitchen/billingProvider";
import { useCountry, useCurrency } from "../../provider/courtryProvider";

import CurrentTabItem from "./CurrentTabItem";
import AddBillModal from "./addBillModal";
import BillSettings from "./billSettings";
import config from "../../config";
import DraftTable from "./draftTable";
import {
  useBillingDraft,
  useBillingDraftForB2b,
  useBillingDraftWithCatch,
} from "../../provider/billingDraftProvider";
import { FiChevronRight } from "react-icons/fi";
import { useCustomerData } from "../../provider/billingProviders/customerDataProvider";
import LoyaltyModal from "./loyaltyModal";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";
import { Popconfirm, Switch } from "antd";
import ShortCutKeyModal from "./shortCutKeyModal";
import { useAccess } from "../../provider/AccessProvider";
import { GENERATEBILLACCESS } from "../../utils/constant";
import {
  useKotDraft,
  useKotDraftWithCatch,
} from "../Kitchen/KOT/draftProvider";
import { useKotDraftB2b } from "../Kitchen/KOT/kotDraftB2bProvider";
import { useDebounce } from "../../hooks/useDebounce";

const BillingTab = () => {
  const [CustomerFoundFrom, setCustomerFoundFrom] = useState();
  const [openAddBill, setOpenAddBill] = useState(false);
  const [isAdvanceSetting, setIsAdvanceSetting] = useState(false);
  const [settingModal, setSettingModal] = useState(false);
  const cutomerNumberRef = useRef();
  const [shortCutKey, setShortCutKey] = useState("");
  const [toggleSwitch, setToggleSwitch] = useSwitchBill();
  const [currentDraft, setCurrentDraft] = useState(true);
  const [billingDraft, setBillingDraft] = useBillingDraft();
  const [kotDraftBill, setKotDraftBill] = useKotDraft();
  const [kotDraftB2bBill, setKotDraftB2bBill] = useKotDraftB2b();
  const [b2bDraft, setB2bDraft] = useBillingDraftForB2b();
  const [loyaltyModal, setLoyaltyModal] = useState(false);
  const customerFetchRef = useRef(false);

  const { uniqueIdentity: identifier = false } = useSelector(
    (state) => state.shopDetails.advanceSettings || {}
  );
  const [customerFetchLoading, setCustomerFetchLoading] = useState(false);
  const {
    clearAll,
    updateProductPriceWhileSwitching,
    state: { b2bBill },
  } = useBilling();
  const country = useCountry();
  const shopDetails = useSelector((state) => state.shopDetails);
  const currencyFormatter = useCurrency();
  const { clearFooterData, setDeliveryAddress } = useFooterData();
  const {
    customerData: customerDatas,
    setCustomerData: setCustomerDatas,
    clearCustomerData,
  } = useCustomerData();
  const access = useAccess(GENERATEBILLACCESS);
  const [alias, setAlias] = useState("");
  const debounceAlias = useDebounce(alias, 500);
  const [draftBillCatch] = useBillingDraftWithCatch();

  const getCustomerDetail = async (customerPhoneNo, uniqueId) => {
    setCustomerFetchLoading(true);
    await Promise.all([
      fetch(`${config.newApiGateway}/customer/getCustomerDetailswithLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          ...(identifier && uniqueId
            ? { uniqueIdentity: uniqueId }
            : {
                phoneNumber: customerPhoneNo
                  ? `${shopDetails.country.dialCode}${customerPhoneNo}`
                  : undefined,
              }),
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.code === "ERROR") {
          setCustomerDatas((prev) => ({
            ...prev,
            customerName: "",
            loyaltyPoints: "",
            outstandingAmount: "",
            availableLoyaltyPoints: "",
            loyalty: {},
            loyaltyDiscount: 0,
          }));
          setDeliveryAddress("", "");
        }
        if (data.customerName) {
          setCustomerDatas((prev) => ({
            ...prev,
            loyalty: {},
            loyaltyDiscount: 0,
            customerName: data.customerName,
          }));
        }
        if (data.customerPhoneNumber) {
          setCustomerDatas((prev) => ({
            ...prev,
            loyalty: {},
            loyaltyDiscount: 0,
            customerPhoneNumber: data.customerPhoneNumber.replace(
              country.dialCode,
              ""
            ),
          }));
        }
        if (data.customerAddress) {
          const billingAddress = data.customerAddress?.billingAddress
            ? data.customerAddress?.billingAddress
            : "";
          const shippingAddress = data.customerAddress?.shippingAddress
            ? data.customerAddress?.shippingAddress
            : "";

          setDeliveryAddress(billingAddress, shippingAddress);
        }
        if (
          identifier &&
          uniqueId &&
          data.customerPhoneNumber &&
          data.customerName
        ) {
          setCustomerFoundFrom("alias");
        } else if (
          data.customerPhoneNumber &&
          data.customerName &&
          data.uniqueIdentity
        ) {
          setCustomerFoundFrom("phoneNumber");
        }
        if (data.uniqueIdentity) {
          setCustomerDatas((prev) => ({
            ...prev,
            uniqueId: data.uniqueIdentity,
          }));
        }
        if (data.loyaltyPoints) {
          setCustomerDatas((prev) => ({
            ...prev,
            loyaltyPoints: data.loyaltyPoints,
            loyaltyDiscount: 0,
            availableLoyaltyPoints: data.loyaltyPoints,
          }));
        }
        if (data.outStanding) {
          setCustomerDatas((prev) => ({
            ...prev,
            outstandingAmount: data.outStanding,
          }));
        }
      })
      .catch((err) => {
        setCustomerDatas((prev) => ({
          ...prev,
          customerName: "",
          loyaltyPoints: 0,
          outstandingAmount: 0,
          customerPhoneNumber: "",
          loyalty: {},
          loyaltyDiscount: 0,
          availableLoyaltyPoints: 0,
        }));
        setDeliveryAddress("", "");
        setCustomerFoundFrom();
        console.error(err);
      })
      .finally(() => {
        // setLoading(false);
        customerFetchRef.current = false;
        setAlias("");
        setCustomerFetchLoading(false);
      });
  };
  const handleUniqueIdentityChange = (e) => {
    const _uniqueId = e.target.value;
    console.log("customerDatas", customerDatas);
    if (customerDatas.customerPhoneNumber && !CustomerFoundFrom) {
      setCustomerDatas((prev) => ({
        ...prev,
        uniqueId: _uniqueId,
      }));
      setAlias(_uniqueId);
      return;
    }
    if (CustomerFoundFrom === "alias") {
      setCustomerDatas((prev) => ({
        ...prev,
        customerName: "",
        customerPhoneNumber: "",
      }));
    }

    setAlias(_uniqueId);
    setCustomerFoundFrom();
    setCustomerDatas((prev) => ({
      ...prev,
      uniqueId: _uniqueId,
      loyaltyPoints: "",
      loyaltyDiscount: 0,
      outstandingAmount: "",
      availableLoyaltyPoints: "",
      loyalty: {},
    }));
    setDeliveryAddress("", "");
  };
  const deleteDraft = async (actionKey) => {
    try {
      const response = await fetch(`${config.newApiGateway}/draft/draft`, {
        method: "POST",
        body: JSON.stringify({
          action: "delete-all",
          actionKey: actionKey,
          shopId: shopDetails.shopId,
          employeeId: shopDetails.empId ? shopDetails.empId : "",
          shopTypeandCustomertype: actionKey,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        if (shopDetails.shopType === "Restaurant" && b2bBill === false) {
          setKotDraftBill([]);
        } else if (shopDetails.shopType === "Restaurant" && b2bBill === true) {
          setKotDraftB2bBill([]);
        } else if (shopDetails.shopType !== "Restaurant" && b2bBill === false) {
          setBillingDraft([]);
        } else if (shopDetails.shopType !== "Restaurant" && b2bBill === true) {
          setB2bDraft([]);
        }
      }
    } catch (err) {
      console.error("Error: deleteDraftById", err);
    }
  };
  const handleDraftRemoveAll = () => {
    if (shopDetails.shopType === "Restaurant" && b2bBill === false) {
      deleteDraft("restaurant");
    } else if (shopDetails.shopType === "Restaurant" && b2bBill === true) {
      deleteDraft("restaurant-b2b");
    } else if (shopDetails.shopType !== "Restaurant" && b2bBill === false) {
      deleteDraft("draft");
    } else if (shopDetails.shopType !== "Restaurant" && b2bBill === true) {
      deleteDraft("draft-b2b");
    }
  };
  const handleDraftClick = () => {
    setCurrentDraft(false);
  };
  const handleCustomerNumberChange = (e) => {
    const value = e.target.value;
    console.log("value", value);
    setCustomerDatas((prev) => ({
      ...prev,
      customerPhoneNumber: value,
    }));
    if (CustomerFoundFrom === "phoneNumber") {
      setCustomerDatas((prev) => ({
        ...prev,
        uniqueId: "",
      }));
    }
    if (!value || value.length !== country.numberLimit) {
      setCustomerFoundFrom();
      setCustomerDatas((prev) => ({
        ...prev,
        customerName: "",
        loyaltyDiscount: 0,
        loyaltyPoints: "",
        outstandingAmount: "",
        availableLoyaltyPoints: "",
        loyalty: {},
      }));
      setDeliveryAddress("", "");
      return;
    }
    // setCustomerPhoneNumber(value);
    // if (value.length !== mobileNumberLimit) {
    //   return;
    // }
    const regExp = /^[0]?[56789]\d{9}$/;
    if (regExp.test(value) === false) {
      setTimeout(() => {
        alert("Enter valid phone number");
      }, 100);
      return;
    }
    //setCustomerDetailsLoading(true);
    if (customerFetchRef.current === false) {
      customerFetchRef.current = true;
      getCustomerDetail(value);
    }
  };

  const data = useMemo(() => {
    if (shopDetails.shopType !== "Restaurant" && b2bBill) {
      const result = draftBillCatch.filter((i) => i.action === "draft-b2b");
      return [...b2bDraft, ...result];
    } else if (shopDetails.shopType !== "Restaurant" && !b2bBill) {
      const result = draftBillCatch.filter((i) => i.action === "draft");
      return [...billingDraft, ...result];
    } else if (shopDetails.shopType === "Restaurant" && b2bBill) {
      const result = draftBillCatch.filter(
        (i) => i.action === "restaurant-b2b"
      );
      return [...kotDraftB2bBill, ...result];
    } else if (shopDetails.shopType === "Restaurant" && !b2bBill) {
      const result = draftBillCatch.filter((i) => i.action === "restaurant");
      return [...kotDraftBill, ...result];
    }
    return data;
  }, [
    b2bBill,
    b2bDraft,
    billingDraft,
    draftBillCatch,
    kotDraftB2bBill,
    kotDraftBill,
    shopDetails.shopType,
  ]);

  useEffect(() => {
    if (!customerDatas.customerPhoneNumber && !customerDatas.customerName) {
      setCustomerFoundFrom();
    }
  }, [customerDatas.customerPhoneNumber, customerDatas.customerName]);

  useEffect(() => {
    console.log("debounceAlias", debounceAlias);
    if (debounceAlias && customerFetchRef.current === false) {
      customerFetchRef.current = true;
      getCustomerDetail(undefined, debounceAlias);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceAlias]);

  return (
    <div
      style={{ background: "#f5f9fc", position: "relative" }}
      className="wholeContainer"
      // onBlur={() => setProductArray([])}
    >
      <div style={{ position: "relative" }} className="twoContainer">
        <div className="leftContainer">
          <div className="invoice-generator-leftHead">
            <div className="invoice-generator-leftSubHead">
              <div
                className={
                  currentDraft
                    ? "invoice-generator-leftSubHead-title1"
                    : "invoice-generator-leftSubHead-title2"
                }
              >
                <BSButton onClick={() => setCurrentDraft(true)} variant="text">
                  Current
                </BSButton>
              </div>
              <div
                className={
                  currentDraft
                    ? "invoice-generator-leftSubHead-title2"
                    : "invoice-generator-leftSubHead-title1"
                }
              >
                <BSButton onClick={handleDraftClick} variant="text">
                  Drafts(
                  {/* {shopDetails.shopType !== "Restaurant" ? (
                    <>{b2bBill ? b2bDraft.length : billingDraft.length}</>
                  ) : (
                    <>
                      {b2bBill ? kotDraftB2bBill.length : kotDraftBill.length}
                    </>
                  )} */}
                  {data.length})
                </BSButton>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="threeLinks">
                {currentDraft && (
                  <>
                    <div>
                      <BSButton
                        variant="text"
                        className="invoice-generator-leftSubHead-link"
                        onClick={() => {
                          setShortCutKey(true);
                        }}
                      >
                        <p> ShortCut Keys</p>
                      </BSButton>
                    </div>
                    <div>
                      <BSButton
                        id="billingAddItem"
                        variant="text"
                        className="invoice-generator-leftSubHead-link"
                        onClick={() => {
                          if (!access.addItem()) {
                            return;
                          }
                          setOpenAddBill(true);
                        }}
                      >
                        <p> + Add New Item</p>
                      </BSButton>
                    </div>
                    <div>
                      <BSButton
                        variant="text"
                        className="button-width invoice-generator-leftSubHead-link"
                        onClick={() => {
                          if (!access.advanceSettings()) {
                            return;
                          }
                          setIsAdvanceSetting(true);
                          setSettingModal(true);
                        }}
                        id="advanceSettingBtn"
                      >
                        <p>Advance Settings</p>
                      </BSButton>
                    </div>
                    <BSButton
                      variant="text"
                      className="button-width invoice-generator-leftSubHead-link"
                      onClick={() => {
                        if (!access.billSettings()) {
                          return;
                        }
                        setSettingModal(true);
                      }}
                      id="billSettingBtn"
                    >
                      <p>Bill Settings</p>
                    </BSButton>
                    <div>
                      <BSButton
                        variant="text"
                        className="invoice-generator-leftSubHead-link"
                        onClick={() => {
                          clearAll();
                          clearCustomerData();
                          clearFooterData();
                          setCustomerFoundFrom();
                        }}
                      >
                        <p>Clear All</p>
                      </BSButton>
                    </div>
                    {/* <div>
                    <BSButton onClick={() => setEnabled(true)}>
                      Take a demo tour
                    </BSButton>
                  </div> */}
                  </>
                )}
                {!currentDraft && (
                  <div>
                    <Popconfirm
                      title="Remove All"
                      description={
                        <p>
                          Are you sure you want to remove everything? <br />
                          This action cannot be undone.
                        </p>
                      }
                      onConfirm={() => handleDraftRemoveAll()}
                      onCancel={() => {}}
                      okText={"Yes"}
                      cancelText={"No"}
                    >
                      <BSButton
                        variant="text"
                        className="invoice-generator-leftSubHead-link"
                      >
                        <p>Remove All</p>
                      </BSButton>
                    </Popconfirm>
                  </div>
                )}
              </div>
              {currentDraft && (
                <div style={{ display: "flex", background: "#ffff" }}>
                  {identifier && (
                    <TextField
                      id="UniqueIdentity"
                      size="small"
                      label={"Alias"}
                      variant="outlined"
                      style={{
                        marginRight: 6,
                        width: 150,
                      }}
                      value={customerDatas.uniqueId}
                      onChange={handleUniqueIdentityChange}
                      inputProps={{
                        maxLength: 10,
                        pattern: "/[A-Za-z]{3}/",
                      }}
                      InputProps={{
                        startAdornment: <></>,
                      }}
                      placeholder={"Flat No or Block No"}
                      disabled={CustomerFoundFrom === "phoneNumber"}
                    />
                  )}
                  <div
                    className="customerDetails-number"
                    style={{
                      marginRight: 5,
                      position: "relative",
                      display: "flex",
                    }}
                  >
                    <TextField
                      id="customerNumberInput"
                      ref={cutomerNumberRef}
                      size="small"
                      label={"Customer Number"}
                      variant="outlined"
                      type="number"
                      disabled={CustomerFoundFrom === "alias"}
                      value={customerDatas.customerPhoneNumber}
                      onChange={handleCustomerNumberChange}
                      inputProps={{
                        maxLength: 10,
                        pattern: "/[A-Za-z]{3}/",
                      }}
                      placeholder={"Customer Number"}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {country.dialCode}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className="customerDetails-name">
                    <TextField
                      size="small"
                      label="Customer Name"
                      InputProps={{
                        startAdornment: <></>,
                      }}
                      variant="outlined"
                      disabled={CustomerFoundFrom === "alias"}
                      value={customerDatas.customerName}
                      placeholder={
                        customerFetchLoading ? "Loading..." : "Customer Name"
                      }
                      onChange={(e) => {
                        setCustomerDatas((prev) => ({
                          ...prev,
                          customerName: e.target.value,
                        }));
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                position: "absolute",
                bottom: -30,
                right: 19,
                zIndex: 1000,
              }}
            >
              {customerDatas.outstandingAmount > 0 && (
                <div
                  style={{
                    marginRight: 7,
                    fontSize: "14px",
                    transition: "all 1s ease-in",
                  }}
                >
                  <span style={{ marginRight: 7, fontSize: "14px" }}>
                    Outstanding
                  </span>
                  <span
                    style={{
                      fontSize: "14px",
                      textDecoration: "none",
                      cursor: "pointer",
                      color: "#CF0000",
                    }}
                  >
                    {customerFetchLoading ? (
                      <Spinner
                        variant="primary"
                        animation="border"
                        size="sm"
                        style={{
                          verticalAlign: "middle",
                        }}
                        className="confirmBillSpinner"
                      />
                    ) : (
                      currencyFormatter(customerDatas.outstandingAmount)
                    )}
                  </span>
                </div>
              )}

              {currentDraft && (
                <>
                  {Math.ceil(
                    (new Date(shopDetails.loyaltyExpiryDate) - new Date()) /
                      (1000 * 60 * 60 * 24)
                  ) > 0 &&
                    shopDetails.loyaltyRatio && (
                      <div
                        style={{ display: "flex", alignItems: "center" }}
                        id="loyaltyPoints"
                      >
                        <div style={{ marginRight: 7, fontSize: "14px" }}>
                          Loyalty Points
                        </div>
                        <div
                          style={{
                            fontSize: "14px",
                            textDecoration: "none",
                            cursor: "pointer",
                            color: "#CF0000",
                          }}
                          onClick={() => {
                            setLoyaltyModal(true);
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <span style={{ fontSize: "14px" }}>
                              {customerFetchLoading ? (
                                <Spinner
                                  variant="primary"
                                  animation="border"
                                  size="sm"
                                  style={{
                                    verticalAlign: "middle",
                                  }}
                                  className="confirmBillSpinner"
                                />
                              ) : (
                                currencyFormatter(
                                  customerDatas.availableLoyaltyPoints
                                )
                              )}
                            </span>
                            <span style={{ marginTop: "-2px" }}>
                              <FiChevronRight />
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                  {shopDetails?.advanceSettings?.b2bPricing && (
                    <Switch
                      size="large"
                      checkedChildren="B2B"
                      unCheckedChildren="B2C"
                      checked={toggleSwitch}
                      onChange={(v) => {
                        if (!access.b2bPricingAccess()) {
                          return;
                        }

                        updateProductPriceWhileSwitching(v);
                        setToggleSwitch(v);
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {currentDraft && <CurrentTabItem />}
      {!currentDraft && (
        <DraftTable goToCurrent={() => setCurrentDraft(true)} />
      )}
      <AddBillModal open={openAddBill} onClose={() => setOpenAddBill(false)} />
      <BillSettings
        isAdvanceSetting={isAdvanceSetting}
        open={settingModal}
        onClose={() => {
          setSettingModal(false);
          setIsAdvanceSetting(false);
        }}
      />
      {shortCutKey && (
        <ShortCutKeyModal
          open={shortCutKey}
          onClose={() => setShortCutKey(false)}
        />
      )}
      <LoyaltyModal
        open={loyaltyModal}
        onClose={() => setLoyaltyModal(false)}
        onApply={() => {
          setLoyaltyModal(false);
        }}
      />
    </div>
  );
};

export default BillingTab;
